
export class PaymentDetails {
  email: String;
  name: String;
  phone: String;
  amount: String;
  txnid: String;
  hash: String;
  surl: String;
  furl: String;
  key: String;
  firstname: String;
  productinfo: String;
  service_provider: String;
  planid: number;
  userid: number;
  promocodeid: number;
  planStatus: String;
  discountType: String;
  discount: String;
  healthCardType :String;
  healthCardCharges: String;
  registrationCharges: String;
  gstAmount: String;
  basicamount: String;
  gstper: String;

  planData: String;
  planExpireDate: String;
  dataAndAmount: string;
  promoCodeName: string;

  previousPlanData: String;
  currentPlanData: String;
  amountPerMB: String;

}


export class updatePlanRequestDto {
  planid: number;
  userid: number;
  healthCardType: string;
  healthCardCharges: number;
  registrationCharges: number;
}

export class HealthCardChargesRequestDto{
  userid:number;
  healthCardCharges:number;
  healthCardType:number;
}